import {getCheckboxConfigBySource} from "../../constants/lead/lead_modal_checkbox_options";
import {ApplicationSource} from "../../utils/form/application_form_source";

export interface IAmplitudeLeadFormCloseFormSnapshot {
    questions?: string[];
    negotiation?: number | null;
}

export type ILeadFormCloseSnapshotFormValues = {
    questions?: string[];
    negotiation?: number | null;
};

export const getLeadFormCloseSnapshotFromFormValues = (values: ILeadFormCloseSnapshotFormValues | unknown): IAmplitudeLeadFormCloseFormSnapshot | undefined => {
    if (!values || typeof values !== "object") {
        return undefined;
    }

    const {questions, negotiation} = values as ILeadFormCloseSnapshotFormValues;
    const snapshot: IAmplitudeLeadFormCloseFormSnapshot = {};

    if (questions?.length) {
        snapshot.questions = questions;
    }

    if (negotiation != null) {
        snapshot.negotiation = negotiation;
    }

    if (snapshot.questions?.length || snapshot.negotiation != null) {
        return snapshot;
    }

    return undefined;
};

export interface ILeadSubmitInquirySelection {
    negotiation?: number | null;
    additionalQuestions?: {value: string; label: string}[];
}

/** Selected topics at successful submit or negotiation price selected by user. */
export const getAmplitudeLeadFormInquiryTopicsSelectedFromSubmit = (source: ApplicationSource, values: ILeadSubmitInquirySelection): string[] => {
    if (source === ApplicationSource.NegotiatePrice && values.negotiation != null) {
        return [String(values.negotiation)];
    }

    const labels = values.additionalQuestions?.map((question) => question.label).filter(Boolean) ?? [];

    return labels.map(String);
};

export const getAmplitudeLeadFormInquiryTopicsSelected = (
    source: ApplicationSource | null,
    snapshot: IAmplitudeLeadFormCloseFormSnapshot | undefined
): string[] => {
    if (source === ApplicationSource.NegotiatePrice && snapshot?.negotiation != null) {
        return [String(snapshot.negotiation)];
    }

    if (!snapshot?.questions?.length) {
        return [];
    }

    const {baseOptions, moreOptions} = getCheckboxConfigBySource(source);
    const allOptions = [...baseOptions, ...moreOptions];

    return snapshot.questions
        .map((value) => allOptions.find((option) => option.value === value))
        .filter((option) => option != null)
        .map((option) => String(option.labelContent));
};
import {getCheckboxConfigBySource} from "../../constants/lead/lead_modal_checkbox_options";
import {ApplicationSource} from "../../utils/form/application_form_source";

export interface IAmplitudeLeadFormCloseFormSnapshot {
    questions?: string[];
    negotiation?: number | null;
}

export type ILeadFormCloseSnapshotFormValues = {
    questions?: string[];
    negotiation?: number | null;
};

export const getLeadFormCloseSnapshotFromFormValues = (values: ILeadFormCloseSnapshotFormValues | unknown): IAmplitudeLeadFormCloseFormSnapshot | undefined => {
    if (!values || typeof values !== "object") {
        return undefined;
    }

    const {questions, negotiation} = values as ILeadFormCloseSnapshotFormValues;
    const snapshot: IAmplitudeLeadFormCloseFormSnapshot = {};

    if (questions?.length) {
        snapshot.questions = questions;
    }

    if (negotiation != null) {
        snapshot.negotiation = negotiation;
    }

    if (snapshot.questions?.length || snapshot.negotiation != null) {
        return snapshot;
    }

    return undefined;
};

export interface ILeadSubmitInquirySelection {
    negotiation?: number | null;
    additionalQuestions?: {value: string; label: string}[];
}

/** Selected topics at successful submit or negotiation price selected by user. */
export const getAmplitudeLeadFormInquiryTopicsSelectedFromSubmit = (source: ApplicationSource, values: ILeadSubmitInquirySelection): string[] => {
    if (source === ApplicationSource.NegotiatePrice && values.negotiation != null) {
        return [String(values.negotiation)];
    }

    const labels = values.additionalQuestions?.map((question) => question.label).filter(Boolean) ?? [];

    return labels.map(String);
};

export const getAmplitudeLeadFormInquiryTopicsSelected = (
    source: ApplicationSource | null,
    snapshot: IAmplitudeLeadFormCloseFormSnapshot | undefined
): string[] => {
    if (source === ApplicationSource.NegotiatePrice && snapshot?.negotiation != null) {
        return [String(snapshot.negotiation)];
    }

    if (!snapshot?.questions?.length) {
        return [];
    }

    const {baseOptions, moreOptions} = getCheckboxConfigBySource(source);
    const allOptions = [...baseOptions, ...moreOptions];

    return snapshot.questions
        .map((value) => allOptions.find((option) => option.value === value))
        .filter((option) => option != null)
        .map((option) => String(option.labelContent));
};
